<template>
  <div id="createFarm">
    <b-card
      class="blockDrawer large"
      :class="$store.state.drawer.createFarm.position"
    >
      <template v-slot:header>
        <a
          class="close clickable"
          @click="closeCreateFarm()"
        >
          <i class="far fa-times"></i>
        </a>
        <h4 class="card-title">Create Farm</h4>
      </template>
      <p>*Click on the map to select a location for your farm.</p>
      <div class="form-group">
        <label for="farmName"><strong>Farm Name</strong></label>
        <input
          v-model="farm.name"
          id="farmName"
          class="form-control"
        />
      </div><!-- /.form-group -->

      <div class="form-group mb-5 pb-5">
        <label><strong>Block Data Headers (Advanced)</strong></label>
        <div class="list-group" v-if="!hideHeaders">
          <draggable
            v-model="farm.blockFields"
            :disabled="draggableDisabled"
            @update="sortByGroup"
          >
            <div
              v-for="(field, i) in farm.blockFields"
              v-bind:key="i"
              class="list-group-item list-group-item-action"
            >
              <p class="mb-0" v-if="field.group">
                <b-badge
                  pill
                  class="mr-1"
                  variant="primary"
                >{{ field.group }}</b-badge>
              </p>
              <p class="lead mb-1" v-bind:class="{ 'text-muted': field.hidden }">
                <!-- <i class="fas fa-minus-circle text-danger clickable mr-2 float-right" @click="farm.blockFields.splice(i, 1)"></i> -->
                <i v-if="field.type == 'Text'" class="fas fa-text"></i>
                <i v-if="field.type == 'Number'" class="fas fa-hashtag"></i>
                <i v-if="field.type == 'Select'" class="far fa-ballot-check"></i>
                <i v-if="field.type == 'Date and Time'" class="far fa-clock"></i>
                <i v-if="field.type == 'Image'" class="fas fa-image"></i>
                &nbsp;{{ field.label }}
                <!-- <b-btn size="sm" @click="editBlockField(i)"><i class="fas fa-pencil clickable"></i></b-btn> -->
              </p>
              <b-btn
                size="sm"
                variant="success"
                @click="editBlockField(i)"
                class="mr-1"
                v-if="!field.hidden"
              ><i class="fas fa-pencil clickable"></i> Edit</b-btn>
              <b-btn
                size="sm"
                variant="success"
                class="mr-1 disabled"
                v-if="field.hidden"
              ><i class="fas fa-pencil clickable"></i> Edit</b-btn>
              <b-btn
                size="sm"
                variant="warning"
                @click="duplicate(field, i)"
                class="mr-1"
                v-if="!field.hidden && field.type !== 'Image'"
              ><i class="far fa-clone clickable"></i> Duplicate</b-btn>
              <b-btn
                size="sm"
                variant="warning"
                class="mr-1 disabled"
                v-if="field.hidden && field.type !== 'Image'"
              ><i class="far fa-clone clickable"></i> Duplicate</b-btn>
              <b-btn
                size="sm"
                class="mr-1"
                @click="hideHeader(i)"
                v-if="!field.hidden"
              ><i class="fas fa-eye-slash"></i> Hide</b-btn>
              <b-btn
                size="sm"
                class="mr-1"
                @click="unhideHeader(i)"
                v-if="field.hidden"
                variant="success"
              ><i class="fas fa-eye-slash"></i> Unhide</b-btn>
              <b-btn
                size="sm"
                variant="danger"
                @click="removeHeader(i)"
                v-if="!field.hidden"
              ><i class="fas fa-minus-circle"></i> Remove</b-btn>
              <b-btn
                size="sm"
                variant="danger"
                class="disabled"
                v-if="field.hidden"
              ><i class="fas fa-minus-circle"></i> Remove</b-btn>
            </div>
          </draggable>
        </div><!-- list-group -->
        <b-btn
          @click="addBlockField()"
          class="mt-2"
        ><i class="far fa-plus"></i> Add a Block Header</b-btn>
      </div><!-- /.form-group -->

      <div class="drawer-footer">
        <button
          @click="saveFarm()"
          class="btn btn-primary w-50 mr-1"
        >Save</button>
        <button
          v-if="$store.state.display.editMode == true && $store.state.role == 'Administrator'"
          @click="confirmDelete = true"
          class="btn btn-danger mr-1"
        >Delete</button>
        <button
          @click="closeCreateFarm()"
          class="btn btn-secondary"
        >
          Cancel
        </button>
      </div><!-- /.float-right -->
    </b-card>
    <!-- ADD BLOCK FIELD MODAL -->
    <AddBlockField :editMode="editMode" :fieldIndex="fieldIndex" v-if="$store.state.display.modal.addBlockField" />
    <Confirm
      v-if="confirmDelete"
      text="DANGER! Are you sure you want to delete this farm?"
      v-on:confirmed="deleteFarm($event)"
    />
    <Confirm
      v-if="removeHeaderConfirm"
      text="DANGER! Are you sure you want to remove this header?"
      v-on:confirmed="removeHeaderForReal($event)"
    />
  </div><!-- /#createFarm -->
</template>

<script>
import AddBlockField from './AddBlockField'
import Confirm from '../Confirm'
import draggable from 'vuedraggable'
import firebase from 'firebase/compat/app'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      confirmDelete: false,
      editMode: false,
      fieldIndex: false,
      draggableDisabled: false,
      hideHeaders: false,
      headerToRemove: false,
      removeHeaderConfirm: false
    }
  },
  components: {
    AddBlockField,
    Confirm,
    draggable
  },
  computed: {
    farm: {
      get () {
        return this.$store.state.farm
      },
      set (value) {
        this.$store.commit('setFarm', value)
      }
    },
    geocoderControl: {
      get () {
        return this.$store.state.geocoderControl
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'geocoderControl', value: value })
      }
    },
    selectMarker: {
      get () {
        return this.$store.state.selectMarker
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'selectMarker', value: value })
      }
    }
  },
  mounted () {
    this.sortByGroup()
    // DISABLE DRAGGABLE ON MOBILE
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    if (vw < 800) {
      this.draggableDisabled = true
    }
    if (this.$store.state.display.editMode === false) {
      console.log('Creating New Farm')
      this.farm.name = ''
      this.farm.geolocation = null
      this.farm.blockFields = []
    }
    this.initMapControls()
  },
  destroyed () {
    if (this.selectMarker) {
      this.selectMarker.remove()
      this.$store.commit('setStateProperty', { property: 'selectMarker', value: false })
    }
    if (this.$store.state.display.editMode === false) {
      const self = this
      fb.farmsCollection.doc(this.$route.params.id).get().then(farmDoc => {
        self.farm = farmDoc.data()
        self.farm.id = farmDoc.id
        console.log(self.farm)
      })
    }
    this.$store.commit('setEditMode', false)
    this.$store.state.mapObject.removeControl(this.$store.state.geocoderControl)
    this.$store.state.mapObject.off('click', this.addMarker)
  },
  methods: {
    duplicate (field, i) {
      const fieldObj = JSON.parse(JSON.stringify(field))
      fieldObj.machine_name = fieldObj.machine_name + '_copy'
      fieldObj.label = fieldObj.label + ' COPY'
      this.farm.blockFields.splice(i + 1, 0, fieldObj)
      console.log(fieldObj)
    },
    sortByGroup () {
      // Create two arrays, one for fields with a group and one for fields without a group
      const withGroup = []
      const withoutGroup = []

      // Populate the two arrays
      this.farm.blockFields.forEach((field, index) => {
        // Add a property 'index' to maintain the original order
        field.index = index
        if (field.group) {
          withGroup.push(field)
        } else {
          withoutGroup.push(field)
        }
      })

      // Sort the 'withGroup' array by the 'group' property
      withGroup.sort((a, b) => {
        if (a.group < b.group) return -1
        if (a.group > b.group) return 1
        return a.index - b.index // In case of equal groups, maintain original order
      })

      // The final sorted array is the concatenation of 'withoutGroup' and 'withGroup'
      this.farm.blockFields = withoutGroup.concat(withGroup)

      // Remove the 'index' property as it's no longer needed
      this.farm.blockFields.forEach(field => {
        delete field.index
      })
    },
    removeHeaderForReal (confirmed) {
      this.removeHeaderConfirm = false
      if (confirmed) {
        this.farm.blockFields.splice(this.headerToRemove, 1)
      }
    },
    removeHeader (index) {
      this.headerToRemove = index
      this.removeHeaderConfirm = true
    },
    unhideHeader (headerIndex) {
      this.hideHeaders = true
      this.farm.blockFields[headerIndex].hidden = false
      this.hideHeaders = false
    },
    hideHeader (headerIndex) {
      this.hideHeaders = true
      this.farm.blockFields[headerIndex].hidden = true
      this.hideHeaders = false
    },
    addBlockField () {
      this.editMode = false
      this.fieldToEdit = false
      this.$store.commit('toggleModal', 'addBlockField')
    },
    editBlockField (i) {
      this.editMode = true
      this.fieldIndex = i
      this.$store.commit('toggleModal', 'addBlockField')
    },
    closeCreateFarm () {
      this.$store.commit('hideDrawer', 'createFarm')
      this.$store.dispatch('fetchFarm', this.$route.params.id)
      const self = this
      setTimeout(function () {
        self.$store.commit('showDrawer', 'farmDetails')
      }, 300)
    },
    deleteFarm (confirmed) {
      // UPDATE 5/11/2022: Upon deletion, simply delete the farm document and remove it as default farm if relevant.
      const farmId = this.$store.state.farm.id
      if (confirmed) {
        this.confirmDelete = false
        if (farmId === this.$store.state.userProfile.defaultFarm) {
          fb.usersCollection.doc(this.$store.state.currentUser.uid).update({
            defaultFarm: false
          })
        }
        this.$store.state.farm.deletedOn = new Date()
        fb.deletedFarmsCollection.doc(farmId).set(this.$store.state.farm).then(() => {
          return fb.farmsCollection.doc(farmId).delete()
        }).then(() => {
          window.location.href = '/'
        })
      } else {
        this.confirmDelete = false
        return false
      }
    },
    addMarker (e) {
      if (this.selectMarker) {
        this.selectMarker.remove()
      }
      const markerOptions = e
      markerOptions.color = '#333'
      // markerOptions.draggable = true
      this.selectMarker = new mapboxgl.Marker(markerOptions) // eslint-disable-line
        .setLngLat(e.lngLat)
        .addTo(this.$store.state.mapObject)
      this.farm.geolocation = new firebase.firestore.GeoPoint(e.lngLat.lat, e.lngLat.lng)
    },
    initMapControls () {
      const map = this.$store.state.mapObject
      // Check for map ready
      if (map.boxZoom) {
        // Map is ready
        map.removeControl(this.$store.state.zoomControl)
        map.removeControl(this.$store.state.locateControl)
        this.geocoderControl = new MapboxGeocoder({ // eslint-disable-line
          accessToken: mapboxgl.accessToken, // eslint-disable-line
          mapboxgl: mapboxgl, // eslint-disable-line
          marker: false,
          zoom: 16,
          flyTo: {
            animate: false
          }
        })
        map.addControl(this.geocoderControl)
        map.addControl(this.$store.state.zoomControl)
        map.addControl(this.$store.state.locateControl)
        // Setup click marker controls
        map.on('click', this.addMarker)
      } else {
        const self = this
        setTimeout(() => {
          self.initMapControls()
        }, 500)
      }
    },
    saveFarm () {
      this.sortByGroup()
      if (!this.farm.geolocation) {
        alert('You must select a location for your farm by searching and/or clicking on the map!')
        return false
      }
      const editMode = this.$store.state.display.editMode
      if (editMode === true) {
        fb.farmsCollection.doc(this.$store.state.farm.id).update({
          blockFields: this.farm.blockFields || [],
          name: this.farm.name || '',
          geolocation: this.farm.geolocation || '',
          updatedOn: new Date(),
          recompileBlocks: true
        }).then(() => {
          this.closeCreateFarm()
          setTimeout(() => {
            this.$store.dispatch('initFarmMap')
          }, 300)
        }).catch(err => {
          console.log(err)
        })
      } else {
        // Create the farm
        fb.farmsCollection.add({
          blockFields: this.farm.blockFields || [],
          name: this.farm.name || '',
          geolocation: this.farm.geolocation || '',
          createdOn: new Date(),
          updatedOn: new Date(),
          ownerId: this.$store.state.currentUser.uid,
          users: [],
          permissions: {}
        }).then(ref => {
          window.location.href = '/f/' + ref.id
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>
